import React from "react";
import { whyUseItems } from "../data/content";

export default function WhyUse() {
  return (
    <>
      <div className="bg-lavender pt-5 pb-5">
        <div className="container">
          <div className="banner-statement">
            Every business has needs &nbsp; Every business requires resources 
            &nbsp; Every business is always searching for new opportunities
          </div>
        </div>
      </div>

      <section className="section-py">
        <div className="container text-center">
          <h2 className="section-title">Why business need to use Selectezi</h2>
          <p className="section-subtitle">
            An integrated environment built to accelerate every facet of
            multi-sector commerce
          </p>

          <div className="row row-cols-2 row-cols-md-3 row-cols-lg-5 g-3 mt-4">
            {whyUseItems.map((item, i) => {
              const Icon = item.icon;
              return (
                <div className="col" key={i}>
                  <div className="why-card">
                    <div className="icon-wrap">
                      <Icon size={24} />
                    </div>
                    <p>{item.text}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>
    </>
  );
}
